import { useAuth, useToast } from "duck";
import {
  GetOrganizationAdminDocument,
  useUpdateOrganizationAdminMutation
} from "requests";
import { FormValues } from "./types";

export const useUpdateAdmin = (_id: number, onSuccess: () => void) => {
  const [auth, setAuth] = useAuth();
  const [update] = useUpdateOrganizationAdminMutation();

  const toast = useToast({ status: "success" });

  return (values: FormValues) =>
    update({
      refetchQueries: [{ query: GetOrganizationAdminDocument }],
      awaitRefetchQueries: true,
      variables: {
        input: {
          _id,
          firstName: values.firstName,
          lastName: values.lastName,
          email: values.email,
          ...(values.pin && { plainPin: +values.pin }),
          ...(values.password && { plainPassword: values.password }),
          image:
            typeof values.image === "number"
              ? { _id: values.image }
              : values.image
        }
      }
    }).then(response => {
      const newUser = response.data?.updateUser?.user;
      if (!newUser) {
        return;
      }
      if (auth.user._id === newUser._id) {
        setAuth(prev => ({ ...prev, user: { ...prev.user, ...newUser } }));
      }
      toast({ description: "Organization Admin is updated successfully." });
      onSuccess();
    });
};
